<script>
  import {getContext, onMount} from 'svelte';
  import {Subject, throttleTime, groupBy, mergeMap} from 'rxjs';
  import {mc} from '@/core';
  import errors from '@/modules/error/error.lang';
  import {Toast} from '@/widgets';

  const LG = getContext('LG');
  const errorMessage$ = new Subject();
  const errorMessageDelay = 1000;

  onMount(() =>
    mc.subscribe('toast', 'info', ({message}) => {
      create({type: 'success', message});
    })
  );

  onMount(() =>
    mc.subscribe('toast', 'error', ({message, code}) => {
      if (code && errors[code]) {
        message = LG(errors[code]) || message;
      }

      errorMessage$.next(message);
    })
  );

  onMount(function mergeSameMessage() {
    errorMessage$
      .pipe(
        groupBy((msg) => msg),
        mergeMap((group$) => group$.pipe(throttleTime(errorMessageDelay)))
      )
      .subscribe((message) => {
        create({type: 'danger', message});
      });
  });

  function create(props) {
    const toast = new Toast({
      target: document.body,
      props,
      intro: true,
    });

    toast.$on('destroyed', toast.$destroy);
  }
</script>
